module.exports = (Promise.resolve(__parcel__require__("./" + "module.b33b4b8d.684ad82d.js"))).then(() => parcelRequire('br0q2'));